/* global SentryDsn, SentryRelease, SentryEnvironment */
import { createApp } from 'vue';
import axios from 'axios';
import Echo from 'laravel-echo';
import MarqueeText from 'vue-marquee-text-component';
import Socket from 'socket.io-client';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import Weather from './components/frontend/weather.vue';
import ExtendedWeather from './components/frontend/extended-weather.vue';
import Ad from './components/frontend/ad.vue';
import Airline from './components/frontend/airline.vue';
import Almanac from './components/frontend/almanac.vue';
import AnimatedRadar from './components/frontend/animated-radar.vue';
import CurrentWeather from './components/frontend/current-weather.vue';
import CustomText from './components/frontend/custom-text.vue';
import DetailedWeather from './components/frontend/detailed-weather.vue';
import OffPeakStatus from './components/frontend/off-peak-status.vue';
import SatelliteRadar from './components/frontend/satellite-radar.vue';
import SideAds from './components/frontend/side-ads.vue';
import WebCam from './components/frontend/webcam.vue';
import IframeEmbed from './components/frontend/iframe-embed.vue';
import { DateToString, Slides } from './mixins';

const app = createApp({
  components: {
    Ad,
    Airline,
    Almanac,
    AnimatedRadar,
    CurrentWeather,
    CustomText,
    DetailedWeather,
    ExtendedWeather,
    IframeEmbed,
    MarqueeText,
    OffPeakStatus,
    SatelliteRadar,
    SideAds,
    Weather,
    WebCam,
  },
  mixins: [
    DateToString,
    Slides,
  ],
  mounted() {
    this.echo = new Echo({
      broadcaster: 'socket.io',
      host: window.location.origin,
      client: Socket,
    });
    this.initializeEcho();
    this.listenForReload();
    this.listenForRadar();
    this.listenForMarquee();
    const vm = this;
    axios.get(`${window.location.origin}/api/get-data`).then((response) => {
      vm.setAllData(response);
      vm.initializeCarousel();
    });
    axios.get(`${window.location.origin}/api/get-marquee`).then((response) => {
      if (response.data.length > 0) {
        vm.marqueeText = vm.textBuffer + response.data + vm.textBuffer;
      } else {
        vm.marqueeText = response.data;
      }
    });
  },
  methods: {
    initializeEcho() {
      const vm = this;
      this.echo
        .channel('weather')
        .listen('WeatherData', (e) => {
          vm.setAllData(e);
        });
    },
    listenForReload() {
      this.echo
        .channel('reload')
        .listen('FrontendReload', () => {
          window.location.reload();
        });
    },
    listenForRadar() {
      const vm = this;
      this.echo
        .channel('radar.update')
        .listen('RadarUpdate', () => {
          vm.radarCacheBuster = new Date();
        });
    },
    listenForMarquee() {
      const vm = this;
      this.echo
        .channel('marquee')
        .listen('MarqueeUpdate', (e) => {
          if (e.text.length > 0) {
            vm.marqueeText = vm.textBuffer + e.text + vm.textBuffer;
          } else {
            vm.marqueeText = e.text;
          }
        });
    },
    setAllData(e) {
      const vm = this;
      vm.getSideAds();
      vm.cacheBuster = new Date();
      vm.info = e.data;
      vm.myComponents = Object.values(vm.info.components);
      if (!vm.myComponents[vm.slideChange]) {
        vm.slideChange = 0;
      }
      vm.setActive(vm.slideChange);
      vm.alert = { active: false, message: '' };
      Object.keys(vm.info.currentConditions).forEach((city) => {
        if (Object.prototype.hasOwnProperty.call(vm.info.currentConditions[city], 'active')) {
          vm.alert.active = true;
          vm.alert.message += vm.textBuffer + vm.info.currentConditions[city].active + vm.textBuffer;
        }
      });
    },
  },
});

app.mount('#app');

Sentry.init({
  app,
  dsn: SentryDsn,
  release: SentryRelease,
  environment: SentryEnvironment,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 0.25,
  tracingOptions: {
    trackComponents: true,
  },
});

export default app;
